import { AfterViewInit, Directive, ElementRef, HostBinding, Input, OnDestroy } from '@angular/core';
import { UiHelper } from '../helpers/ui.helper';

@Directive({
  selector: '[navbarFixer]',
})
export class NavbarFixerDirective implements AfterViewInit, OnDestroy {
  /*

  Usage notes:

  <p navbarFixer id=example">

  Id artritube must be passed.
  [orderElement]: Order element.
  [displaySet]: For no height and width elements. If breaking styles, can change.
  [offsetAction]: Start action point in px.
  [fixingType]: downHide, fixed.
   */

  elemID = '';
  @Input() fixingType = 'fixed';
  @Input() offsetAction = 250;
  @Input() orderElement = 5;
  @Input() displaySet = 'block';
  @Input() __elemW = '100%';
  @Input() savePostion = false;
  @HostBinding('style.top') elemTop: string;
  @HostBinding('style.left') elemLeft: string;
  @HostBinding('style.position') elemPos: string;
  @HostBinding('style.display') elemDisp = 'block';
  @HostBinding('style.width') elemW = '100%';
  @HostBinding('style.z-index') elemZ = '50';
  elemHeight;
  _navbarElemList = [];
  offsetCumulativer = 0;
  downCumulativer = 0;
  upCumulativer = 0;
  lastViewPortPx = 0;

  constructor(private el: ElementRef, private _UiHelper: UiHelper) {}

  deleteItem(_id: string) {
    this._navbarElemList.forEach((x, c) => {
      if (x.id == _id) {
        this._navbarElemList.splice(c, 1);
        this._UiHelper.setNavbarElemList(this._navbarElemList);
      }
    });
  }

  ngAfterViewInit(): void {
    this.elemDisp = this.displaySet;
    this.elemW = this.__elemW;
    const el1 = this.el.nativeElement;
    this._navbarElemList = this._UiHelper.navbarElemList;
    this.el.nativeElement.classList.add('navbar-fixed-animation');

    this.elemLeft = this.el.nativeElement.offsetLeft + 'px';
    this.elemW = this.el.nativeElement.offsetWidth + 'px';
    this.elemHeight = this.el.nativeElement.clientHeight;
    ////console.log(this.elemLeft, this.elemW);

    this.elemID = this.el.nativeElement.attributes['0'].value;
    ////console.log(this.el.nativeElement.attributes);
    const _elemData = {
      id: this.elemID,
      height: this.elemHeight,
      order: this.orderElement,
      strategy: this.fixingType,
      offsetAction: this.offsetAction,
      calculatedOffsetPx: 0,
      downOffsetPx: 0,
      upOffsetPx: 0,
    };

    this._navbarElemList.push(_elemData);

    this._navbarElemList.sort((a, b) => {
      return a['order'] - b['order'];
    });
    this._navbarElemList.map(x => {
      x.calculatedOffsetPx = this.offsetCumulativer;
      this.offsetCumulativer += x.height;
      if (x.strategy == 'fixed') {
        x.downOffsetPx = this.downCumulativer;
        this.downCumulativer += x.height;
        x.upOffsetPx = this.upCumulativer;
        this.upCumulativer += x.height;
      } else if (x.strategy == 'downHide') {
        x.downOffsetPx = -x.height;
        x.upOffsetPx = this.upCumulativer;
        this.upCumulativer += x.height;
      }
      return x;
    });

    this._UiHelper.documentScrollListener.subscribe(x => {
      if (x > this.offsetAction) {
        this._UiHelper.setContentMarginTop(this.offsetCumulativer);
        if (x < this.lastViewPortPx) {
          // Up
          this.elemTop = -150 + 'px';
          let elemTopC = 0;
          this._navbarElemList.forEach(x => {
            this.elemID == x.id ? (elemTopC = x.upOffsetPx) : null;
          });
          this.elemTop = elemTopC + 'px';
          this.elemPos = 'fixed';
        } else {
          // Down
          this.elemTop = -150 + 'px';
          let elemTopC = 0;
          this._navbarElemList.forEach(x => {
            this.elemID == x.id ? (elemTopC = x.downOffsetPx) : null;
          });
          this.elemTop = elemTopC + 'px';
          this.elemPos = 'fixed';
        }
        this.lastViewPortPx = x;
      } else {
        // Offset else area.
        this.elemTop = 0 + '';
        this.elemPos = 'static';
        this._UiHelper.setContentMarginTop(0);
      }
    });

    this._UiHelper.setNavbarElemList(this._navbarElemList);
  }

  ngOnDestroy(): void {
    //////console.log('destroyed');
    this.deleteItem(this.elemID);
  }
}
